import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
export function DidYouKnow() {
  const facts = ['Pfotenlecken ist in 40% der Fälle ein Darmsignal', 'Die Darm-Haut-Achse ist wissenschaftlich belegt', 'Ein gesunder Darm reduziert systemische Entzündungen im ganzen Körper'];
  return <section className="w-full py-12 px-4 md:px-8" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-warmBrown text-cream rounded-2xl p-8 md:p-10 shadow-lg relative overflow-hidden" data-id="element-61">
          {/* Decorative background element */}
          <div className="absolute -right-10 -top-10 opacity-10" data-id="element-62">
            <Lightbulb size={200} data-id="element-63" />
          </div>

          <div className="relative z-10" data-id="element-64">
            <div className="flex items-center gap-3 mb-6" data-id="element-65">
              <Lightbulb className="text-cream" size={28} data-id="element-66" />
              <h2 className="font-handwritten text-3xl md:text-4xl font-bold" data-id="element-67">
                Wusstest du das?
              </h2>
            </div>

            <ul className="space-y-4" data-id="element-68">
              {facts.map((fact, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + index * 0.1
            }} className="flex items-start gap-3 font-serif text-lg" data-id="element-69">
                  <span className="text-cream/60 mt-1" data-id="element-70">•</span>
                  <span data-id="element-71">{fact}</span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}